import { NavItem } from '@ukam/shell/layouts/full/vertical/sidebar/nav-item/nav-item';

export const laasNav: NavItem[] = [
  { navCap: 'Dashboard' },
  { displayName: 'Loans', iconName: 'solar:pie-chart-2-linear', route: '/loans/dashboard' },
  { navCap: 'Loans' },
  { displayName: 'Simulations', iconName: 'solar:calculator-outline', route: '/loan-simulations' },
  { displayName: 'Loans', iconName: 'solar:clipboard-text-linear', route: '/loans' },
  { navCap: 'Credito do Trabalhador' },
  { displayName: 'Employment Relationships', iconName: 'solar:users-group-rounded-linear', route: '/private-payroll-employment-relationships' },
  { displayName: 'Employee Data', iconName: 'solar:user-id-linear', route: '/private-payroll-employee-data' },
  { displayName: 'FGTS Balances', iconName: 'solar:safe-square-linear', route: '/private-payroll-fgts-balances' },

  {
    displayName: 'Auction',
    iconName: 'solar:sledgehammer-linear',
    children: [
      { displayName: 'Requests', iconName: 'solar:hand-money-linear', route: '/private-payroll-proposal-requests' },
      { displayName: 'Proposals', iconName: 'solar:document-add-linear', route: '/private-payroll-proposals' },
      { displayName: 'Request Syncs', iconName: 'solar:refresh-circle-linear', route: '/private-payroll-proposal-syncs' },
      { displayName: 'Subscriptions', iconName: 'solar:users-group-rounded-linear', route: '/private-payroll-proposal-subscriptions' },
      { displayName: 'Deliveries', iconName: 'solar:plain-2-linear', route: '/private-payroll-proposal-deliveries' },
    ]
  },

  { navCap: 'Consignado INSS' },
  { displayName: 'INSS Benefit Lists', iconName: 'solar:list-check-linear', route: '/social-security-benefit-lists' },
  { displayName: 'INSS Benefit Data', iconName: 'solar:document-text-linear', route: '/social-security-benefits' },
  { displayName: 'Interest Rates', iconName: 'solar:graph-up-linear', route: '/social-security-interest-rates' },
  { displayName: 'Competence Calendar', iconName: 'solar:calendar-linear', route: '/social-security-competences' },

  { navCap: 'Cobranca' },
  { displayName: 'Charges', iconName: 'solar:bill-list-linear', route: '/charges' },
  { displayName: 'Payments', iconName: 'solar:card-transfer-linear', route: '/payments' },
  { displayName: 'Billings', iconName: 'solar:bill-check-linear', route: '/billings' },
  { navCap: 'Conta' },
  { displayName: 'Accounts', iconName: 'solar:wallet-money-linear', route: '/accounts' },
  { navCap: 'Arquivos' },
  { displayName: 'Files', iconName: 'solar:folder-linear', route: '/files' },
  { displayName: 'Finder', iconName: 'solar:magnifer-linear', route: '/file-finder' }
];
